<template>
  <div class="form-group">
    <label class="control-label" for="grades-select">Grades</label>
    <multi-select
      id="grades-select"
      block
      :disabled="disabled"
      @change="selectedChange"
      v-model="selectedInternal"
      :options="multiselectOptions" />
  </div>
</template>

<script>
import { MultiSelect } from 'uiv'
import { gradeSort } from '@/util/gradesort'

export default {
  name: 'SelectGrades',
  components: { MultiSelect },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedInternal: this.selected || []
    }
  },
  computed: {
    multiselectOptions() {
      if (!this.options) {
        return []
      }
      return this.options.map(o => ({
        label: o,
        value: o
      }))
    }
  },
  methods: {
    selectedChange() {
      this.$emit('update:selected', gradeSort(this.selectedInternal))
    }
  },
  watch: {
    selected(newValue) {
      this.selectedInternal = newValue || []
    }
  }
}
</script>

<style lang="less" scoped>
</style>
